import { Link } from 'react-router-dom';

export default function Footer() {
  const services = [
    { name: '水塔清洗', path: '/services/water-tank' },
    { name: '水管水刀疏通', path: '/services/pipe-cleaning' },
    { name: '水溝清洗', path: '/services/drain-cleaning' },
    { name: '內視鏡檢查', path: '/services/endoscope' },
  ];

  const quickLinks = [
    { name: '首頁', path: '/' },
    { name: '施工案例', path: '/cases' },
    { name: '關於我們', path: '/about' },
    { name: '聯絡我們', path: '/contact' },
  ];

  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* 品牌介紹 */}
          <div className="col-span-2 md:col-span-1">
            <h2 className="text-2xl font-bold mb-2">永業環保</h2>
            <p className="text-blue-200 text-sm mb-4">專業管道清潔專家</p>
            <p className="text-blue-100 text-sm leading-relaxed">
              20年專業經驗,提供水塔清洗、管道疏通、水溝清理及內視鏡檢查等全方位環保清潔服務,守護您的用水安全。
            </p>
            <div className="mt-6">
              <a href="https://line.me/ti/p/wJ4U8JR3pC" target="_blank" rel="noopener noreferrer" className="inline-block cursor-pointer">
                <img
                  src="https://static.readdy.ai/image/c61c43d626627dd077148c0c867066d5/7052ea82e329e82c5f01b86dda25596f.jpeg"
                  alt="LINE QR Code"
                  className="w-24 h-24 object-contain bg-white rounded-lg p-1"
                />
              </a>
              <p className="text-blue-200 text-xs mt-2">掃描加入 LINE 諮詢</p>
            </div>
          </div>

          {/* 服務項目 */}
          <div>
            <h3 className="text-base font-semibold mb-5 tracking-wide">服務項目</h3>
            <ul className="space-y-3">
              {services.map((s, i) => (
                <li key={i}>
                  <Link
                    to={s.path}
                    className="text-blue-200 hover:text-white text-sm transition-colors flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 快速連結 */}
          <div>
            <h3 className="text-base font-semibold mb-5 tracking-wide">快速連結</h3>
            <ul className="space-y-3">
              {quickLinks.map((l, i) => (
                <li key={i}>
                  <Link
                    to={l.path}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="text-blue-200 hover:text-white text-sm transition-colors flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 聯絡資訊 */}
          <div>
            <h3 className="text-base font-semibold mb-5 tracking-wide">聯絡資訊</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-blue-300 text-base"></i>
                </div>
                <div>
                  <p className="text-blue-200 text-xs mb-0.5">免費服務專線</p>
                  <a href="tel:0800-281-281" className="text-white text-sm font-medium hover:text-blue-200 transition-colors whitespace-nowrap">0800-281-281</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-smartphone-line text-blue-300 text-base"></i>
                </div>
                <div>
                  <p className="text-blue-200 text-xs mb-0.5">行動電話</p>
                  <a href="tel:0906629777" className="text-white text-sm font-medium hover:text-blue-200 transition-colors whitespace-nowrap">0906-629-777</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-time-line text-blue-300 text-base"></i>
                </div>
                <div>
                  <p className="text-blue-200 text-xs mb-0.5">服務時間</p>
                  <p className="text-white text-sm">全年無休</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-blue-300 text-base"></i>
                </div>
                <div>
                  <p className="text-blue-200 text-xs mb-0.5">服務地區</p>
                  <p className="text-white text-sm">台北 新北 桃竹苗</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* 底部版權 */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-center md:text-left">
          <p className="text-blue-300 text-xs">© 2025 永業環保有限公司 版權所有</p>
          <p className="text-blue-300 text-xs">專業管道清潔 ·水刀疏通 ·水塔清洗 · 水溝疏通 · 內視鏡檢查</p>
        </div>
      </div>
    </footer>
  );
}